import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Pages (à créer progressivement)
import HomePage from './pages/HomePage';
import SurveyPage from './pages/SurveyPage';
import RegisterPage from './pages/RegisterPage';
import PricingPage from './pages/PricingPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminSurveys from './pages/admin/AdminSurveys';
import AdminReport from './pages/admin/AdminReport';
import AdminReports from './pages/admin/AdminReports';
import AdminAlerts from './pages/admin/AdminAlerts';
import AdminSurveyForm from './pages/admin/AdminSurveyForm';
import AdminSurveyDetail from './pages/admin/AdminSurveyDetail';
import AdminSubscription from './pages/admin/AdminSubscription';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import PolitiqueConfidentialitePage from './pages/PolitiqueConfidentialitePage';
import CguPage from './pages/CguPage';
import ScrollToTop from './components/ScrollToTop';
import BackToTopButton from './components/BackToTopButton';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <a href="#main-content" className="skip-link">
        Aller au contenu principal
      </a>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
        <Route path="/cgu" element={<CguPage />} />
        <Route path="/s/:token" element={<SurveyPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="surveys" replace />} />
          <Route path="login" element={<AdminLogin />} />
          <Route path="surveys" element={<AdminSurveys />} />
          <Route path="surveys/new" element={<AdminSurveyForm />} />
          <Route path="surveys/:id/edit" element={<AdminSurveyForm />} />
          <Route path="surveys/:id/report" element={<AdminReport />} />
          <Route path="surveys/:id" element={<AdminSurveyDetail />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="alerts" element={<AdminAlerts />} />
          <Route path="subscription" element={<AdminSubscription />} />
        </Route>
      </Routes>
      <BackToTopButton />
    </BrowserRouter>
  );
}

export default App;
